import { render, staticRenderFns } from "./ylWatch.vue?vue&type=template&id=393eff14&scoped=true&"
import script from "./ylWatch.vue?vue&type=script&lang=js&"
export * from "./ylWatch.vue?vue&type=script&lang=js&"
import style0 from "./ylWatch.vue?vue&type=style&index=0&id=393eff14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393eff14",
  null
  
)

export default component.exports